module.exports = __webpack_public_path__ + "img/yszc-zs.bf3c10aa.png";